/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalCredentialsListGcpIam } from "../funcs/externalCredentialsListGcpIam.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListExternalCredentialsResult } from "../models/components/listexternalcredentialsresult.js";
import {
  ListGcpIamCredentialsRequest,
  ListGcpIamCredentialsSecurity,
} from "../models/operations/listgcpiamcredentials.js";
import { unwrapAsync } from "../types/fp.js";
export type ListGcpIamCredentialsQueryData = ListExternalCredentialsResult;

export function prefetchListGcpIamCredentials(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGcpIamCredentialsRequest | undefined,
  security?: ListGcpIamCredentialsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListGcpIamCredentialsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListGcpIamCredentialsQuery(
  client$: GramCore,
  request?: ListGcpIamCredentialsRequest | undefined,
  security?: ListGcpIamCredentialsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListGcpIamCredentialsQueryData>;
} {
  return {
    queryKey: queryKeyListGcpIamCredentials({
      gramSession: request?.gramSession,
    }),
    queryFn: async function listGcpIamCredentialsQueryFn(
      ctx,
    ): Promise<ListGcpIamCredentialsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalCredentialsListGcpIam(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListGcpIamCredentials(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "externalCredentials", "listGcpIam", parameters];
}
